import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/StudentAchievements/StudentAchievements.tsx");
